/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
import moment from 'moment';
import { getAssignmentsFromTaskRawAssignment } from '../../../../utils/barnBoardHelper';
import { primary } from '../../../../utils/brandColors';
import { getContrast } from '../../../../utils/scheduleHelper';
import { getBarnHorsesForTags } from '../../../../utils/tagsHelper';

const getConfiguredValue = (values, fieldName) => {
  if (!fieldName) return undefined;
  return values?.[fieldName];
};

export const getDaysBetweenDatesObject = (startDate, endDate) => {
  const dates = {};
  const now = startDate.clone();

  while (now.isSameOrBefore(endDate)) {
    dates[now.startOf('day').toDate().getTime()] = [];
    now.add(1, 'days').startOf('day');
  }

  return dates;
};

export const getItemName = (event, workflow) => {
  const eventTemplate = event.resource.eventTemplate.children.find(
    (et) => et.id === workflow.eventTemplateId,
  );
  if (!eventTemplate || eventTemplate.name === event.title) {
    return event.title;
  }
  return `${eventTemplate.name} (${event.title})`;
};

export const buildOverviewDayTaskData = (
  start,
  end,
  events,
  tasks,
) => {
  const dayTaskData = {};

  if (events && tasks && (events.length > 0 || tasks.length > 0)) {
    const startDate = moment(start);
    const endDate = moment(end);
    const now = startDate.clone();

    while (now.isSameOrBefore(endDate)) {
      dayTaskData[now.startOf('day').toDate().getTime()] = {
        incompleteTasks: [],
        completedTasks: [],
        scheduledTasks: [],
      };
      now.add(1, 'days').startOf('day');
    }

    // First loop over each task and add to incomplete or complete for the day
    for (let i = 0; i < tasks.length; i += 1) {
      const dayKey = moment(tasks[i].startDate)
        .startOf('day')
        .toDate()
        .getTime();
      if (dayTaskData[dayKey]) {
        const completed = !!tasks[i].completeDate
        if (completed) {
          dayTaskData[dayKey].completedTasks.push(tasks[i])
        } else {
          dayTaskData[dayKey].incompleteTasks.push(tasks[i])
        }
      }
    }
    // Last loop over all scheduled (not started) events and add to scheduledTasks
    const notStartedEvents = events.filter((e) => !e.inPast && (e.horseTask || e.barnTask));
    for (let i = 0; i < notStartedEvents.length; i += 1) {
      const dayKey = moment(notStartedEvents[i].start)
        .startOf('day')
        .toDate()
        .getTime();
      if (dayTaskData[dayKey]) {
        dayTaskData[dayKey].scheduledTasks.push(notStartedEvents[i])
      }
    }
  }
  return dayTaskData;
}

export const buildPlanningDayOverviewData = (
  start,
  end,
  events,
  tasks,
  staff,
  barnHorses,
  barnUsersMap,
  barnHorsesMap,
) => {
  const mappedTasks = tasks;
  const matchedTasks = new Set();
  let horsesMissingTask = barnHorses
  const staffTasks = {};
  for (let i = 0; i < staff.length; i += 1) {
    if (!staffTasks[staff[i].id]) {
      staffTasks[staff[i].id] = []
    }
  }
  const tasksByType = {}

  // Loop over events
  for (let i = 0; i < events.length; i += 1) {
    // loop over workfows (tasks) in each schedule
    for (let j = 0; j < events[i].resource.workflows.length; j += 1) {
      for (
        let o = 0;
        o < events[i].resource.workflows[j].tagIds.length;
        o += 1
      ) {
        // Tag for workflow, could be horse or location, add if it is in map
        const tagId = events[i].resource.workflows[j].tagIds[o];
        const assignments = getAssignmentsFromTaskRawAssignment(events[i].resource.workflows[j].startingAssignment || '', barnUsersMap);
        const task = events[i].resource.eventTemplate;

        // Remove horse from horses list
        horsesMissingTask = horsesMissingTask.filter((h) => parseInt(h, 10) !== tagId)

        // Check assignments and add to Staff (if applicable)
        for (let k = 0; k < assignments.length; k += 1) {
          if (assignments[k] && staffTasks[assignments[k].id]) {
            staffTasks[assignments[k].id].push({
              taskId: task.id,
              horseId: tagId,
              barnHorse: barnHorsesMap[parseInt(tagId, 10)]
                && barnHorsesMap[parseInt(tagId, 10)][0],
              task,
            })
          }
        }

        // Check task type add add
        if (!tasksByType[task.id]) {
          tasksByType[task.id] = [];
        }
        tasksByType[task.id].push({
          horseId: tagId,
          assignments,
          barnHorse: barnHorsesMap[parseInt(tagId, 10)]
            && barnHorsesMap[parseInt(tagId, 10)][0],
        })

        // map to any task (if created)
        for (let p = 0; p < mappedTasks.length; p += 1) {
          if (
            (events[i].resource.id === mappedTasks[p].scheduleId
              || (events[i].resource.parentSchedule
                && events[i].resource.parentSchedule.id
                === mappedTasks[p].scheduleId)) // schedules match
            && events[i].resource.workflows[j].eventTemplateId
            === mappedTasks[p].eventTemplateId // event templates match
            && moment(mappedTasks[p].startDate).toDate().getTime()
            === (events[i].start.getTime() - events[i].resource.advanceNotice
              || 0)
            && mappedTasks[p].tags.filter((t) => t.id === tagId).length > 0
          ) {
            matchedTasks.add(mappedTasks[p]);
          }
        }
      }
    }
  }

  // loop over remaining unmapped tasks
  const remainingTasks = mappedTasks.filter((task) => !matchedTasks.has(task));
  for (let i = 0; i < remainingTasks.length; i += 1) {
    for (let j = 0; j < remainingTasks[i].tags.length; j += 1) {
      const tagId = remainingTasks[i].tags[j].id;
      const assignments = getAssignmentsFromTaskRawAssignment(
        (remainingTasks[i].currentEventStatus
          && remainingTasks[i].currentEventStatus.assignment)
        || '',
        barnUsersMap,
      )
      const taskId = remainingTasks[i].eventTemplateId;

      // Remove horse from horses list
      horsesMissingTask = horsesMissingTask.filter((h) => parseInt(h, 10) !== tagId)

      // Check assignments and add to Staff (if applicable)
      for (let k = 0; k < assignments.length; k += 1) {
        if (assignments[k] && staffTasks[assignments[k].id]) {
          staffTasks[assignments[k].id].push({
            taskId,
            horseId: tagId,
          })
        }
      }

      // Check task type add add
      if (!tasksByType[taskId]) {
        tasksByType[taskId] = [];
      }
      tasksByType[taskId].push({
        horseId: tagId,
        assignments,
      })
    }
  }

  return {
    horsesMissingTask,
    staffTasks,
    tasksByType,
  };
}

export default (
  location,
  barnHorses,
  barnUsersMap,
  events,
  tasks,
  startDate,
  endDate,
  horseTagTypeId,
  barnHorsesMap,
  barnMetadata = {},
  eventDataMap = {},
  statuses = [],
) => {
  const mappedTasks = tasks;
  const matchedTasks = new Set();
  const nowTimestamp = new Date().getTime();
  const billablePriceFieldName = eventDataMap[barnMetadata.horseBillablePriceEventDataId]?.name;
  const horseNoteFieldName = eventDataMap[barnMetadata.horseNoteTypeEventDataId]?.name;

  // add location and barn horses as objects with dates as fields
  const overview = {
    [location.pingumTagId]: getDaysBetweenDatesObject(
      moment(startDate),
      moment(endDate),
    ),
  };
  for (let i = 0; i < barnHorses.length; i += 1) {
    if (barnHorsesMap[barnHorses[i].pingumTagId]) {
      // Only add if in the barn horse map. If a barn horse is here but not in map, it likely was marked inactive during this search time period
      overview[barnHorses[i].pingumTagId] = getDaysBetweenDatesObject(
        moment(startDate),
        moment(endDate),
      );
    }
  }

  // loop over schedules and their workflows, adding each tag to the map
  for (let i = 0; i < events.length; i += 1) {
    // loop over workfows (tasks) in each schedule
    for (let j = 0; j < events[i].resource.workflows.length; j += 1) {
      const dayKey = moment(events[i].start).startOf('day').toDate().getTime();
      const endOfDayTimestamp = moment(dayKey).endOf('day').toDate().getTime();

      // loop over each tag in a workflow (task)
      for (
        let o = 0;
        o < events[i].resource.workflows[j].tagIds.length;
        o += 1
      ) {
        // Tag for workflow, could be horse or location, add if it is in map
        const tagId = events[i].resource.workflows[j].tagIds[o];
        if (overview[tagId] && overview[tagId][dayKey]) {
          const overviewItem = {
            id: `overview-item-${dayKey}-${events[i].resource.id}-${tagId}`,
            event: {
              ...events[i],
              workflowTagId: tagId,
            },
            taskTypeId: events[i].resource.eventTemplate.id,
            calendarEvent: false,
            name: getItemName(events[i], events[i].resource.workflows[j]),
            complete:
              (!events[i].resource.workflows[j].createEvents
                && events[i].isPast)
              || false,
            scheduled: !events[i].inPast && !events[i].activeNow,
            assignment: getAssignmentsFromTaskRawAssignment(
              events[i].resource.workflows[j].startingAssignment || '',
              barnUsersMap,
            ),
            color: events[i].color,
            textColor: events[i].textColor,
            overdue:
              events[i].dueDate
              && new Date(events[i].dueDate).getTime() < nowTimestamp,
            sortDateTimestamp:
              (!events[i].resource.workflows[j].createEvents
                && events[i].isPast)
                || false
                ? new Date(events[i].start + 86400000).getTime() // we want complete events to sort at bottom of lists (adding 24 hours)
                : events[i].allDay // if it is an all day task we will push below any tasks today that have specific times
                  ? endOfDayTimestamp
                  : new Date(events[i].start).getTime(),
            billablePrice: getConfiguredValue(events[i].resource.workflows[j].eventDataDefaultValues, billablePriceFieldName),
            horseNote: getConfiguredValue(events[i].resource.workflows[j].eventDataDefaultValues, horseNoteFieldName),
            customStatus:
              events[i].resource.workflows[j].startingStatusId
              && statuses.find(
                (s) => s.id === events[i].resource.workflows[j].startingStatusId
                  && s.id !== barnMetadata.statusStartId
                  && s.id !== barnMetadata.statusPendingId
                  && s.id !== barnMetadata.statusEndId,
              ),
          };
          // loop over events and find any mapped events
          for (let p = 0; p < mappedTasks.length; p += 1) {
            if (
              (events[i].resource.id === mappedTasks[p].scheduleId
                || (events[i].resource.parentSchedule
                  && events[i].resource.parentSchedule.id
                  === mappedTasks[p].scheduleId)) // schedules match
              && events[i].resource.workflows[j].eventTemplateId
              === mappedTasks[p].eventTemplateId // event templates match
              && moment(mappedTasks[p].startDate).toDate().getTime()
              === (events[i].start.getTime() - events[i].resource.advanceNotice
                || 0)
              && mappedTasks[p].tags.filter((t) => t.id === tagId).length > 0
            ) {
              matchedTasks.add(mappedTasks[p]);
              overviewItem.id = `overview-item-${dayKey}-${events[i].resource.id}-${tagId}-${mappedTasks[p].id}`;
              overviewItem.task = mappedTasks[p];
              overviewItem.name = mappedTasks[p].name;
              overviewItem.complete = !!mappedTasks[p].completeDate;
              overviewItem.assignment = getAssignmentsFromTaskRawAssignment(
                (mappedTasks[p].currentEventStatus
                  && mappedTasks[p].currentEventStatus.assignment)
                || '',
                barnUsersMap,
              );
              overviewItem.sortDateTimestamp = mappedTasks[p].completeDate
                ? new Date(mappedTasks[p].completeDate + 86400000).getTime() // we want complete events to sort at bottom of lists (adding 24 hours)
                : new Date(mappedTasks[p].startDate).getTime();
              overviewItem.billablePrice = getConfiguredValue(mappedTasks[p].eventData, billablePriceFieldName)?.value;
              overviewItem.customStatus = statuses.find(
                (s) => s.id === (mappedTasks[p].currentEventStatus
                  && mappedTasks[p].currentEventStatus.status
                  && mappedTasks[p].currentEventStatus.status.id)
                  && s.id !== barnMetadata.statusStartId
                  && s.id !== barnMetadata.statusPendingId
                  && s.id !== barnMetadata.statusEndId,
              );
            }
          }
          // If this item is in the past and we don't have a task, it is archived
          if (!overviewItem.task && overviewItem.event.inPast) {
            overviewItem.archived = true;
          }
          overview[tagId][dayKey].push(overviewItem); // Add to the overview object
        }
      }
    }
  }

  // Add a record for calendar events
  const calendarEvents = events.filter((e) => e.eventTask);
  for (let i = 0; i < calendarEvents.length; i += 1) {
    const dayKey = moment(calendarEvents[i].start)
      .startOf('day')
      .toDate()
      .getTime();
    // loop over each barn horse in event
    const barnHorsesForCalendarEvent = getBarnHorsesForTags(
      calendarEvents[i].resource.tags,
      horseTagTypeId,
      barnHorsesMap,
    );
    const color
      = calendarEvents[i].resource.metadata.calendarDisplayColor
      || calendarEvents[i].resource.eventTemplate.eventDataDefaultValues
        .calendarDisplayColor
      || primary.main;
    if (barnHorsesForCalendarEvent) {
      for (let j = 0; j < barnHorsesForCalendarEvent.length; j += 1) {
        if (
          barnHorsesForCalendarEvent[j]
          && overview[barnHorsesForCalendarEvent[j].pingumTagId]
          && overview[barnHorsesForCalendarEvent[j].pingumTagId][dayKey]
        ) {
          overview[barnHorsesForCalendarEvent[j].pingumTagId][dayKey].push({
            id: `overview-calendar-item-${dayKey}-${calendarEvents[i].resource.id}-${barnHorsesForCalendarEvent[j].pingumTagId}`,
            event: calendarEvents[i],
            taskTypeId: calendarEvents[i].resource.eventTemplate.id,
            calendarEvent: true,
            name: calendarEvents[i].title,
            complete: false,
            scheduled:
              !calendarEvents[i].inPast && !calendarEvents[i].activeNow,
            participants: getAssignmentsFromTaskRawAssignment(
              calendarEvents[i].resource.assignment || '',
              barnUsersMap,
            ),
            color,
            textColor: getContrast(color),
            sortDateTimestamp: calendarEvents[i].start.getTime(),
          });
        }
      }
    }
  }
  // add any remaining tasks not already mapped to a schedule
  const remainingTasks = mappedTasks.filter((task) => !matchedTasks.has(task));
  for (let i = 0; i < remainingTasks.length; i += 1) {
    for (let j = 0; j < remainingTasks[i].tags.length; j += 1) {
      const tag = remainingTasks[i].tags[j];
      const dayKey = moment(remainingTasks[i].startDate)
        .startOf('day')
        .toDate()
        .getTime();
      const color
        = (remainingTasks[i].eventData.Color
          && remainingTasks[i].eventData.Color.value)
        || primary.main;
      if (overview[tag.id] && overview[tag.id][dayKey]) {
        overview[tag.id][dayKey].push({
          event: null,
          calendarEvent: false,
          task: remainingTasks[i],
          taskTypeId: remainingTasks[i].eventTemplateId,
          name: remainingTasks[i].name,
          complete: !!remainingTasks[i].completeDate,
          scheduled: false,
          assignment: getAssignmentsFromTaskRawAssignment(
            (remainingTasks[i].currentEventStatus
              && remainingTasks[i].currentEventStatus.assignment)
            || '',
            barnUsersMap,
          ),
          color,
          textColor: getContrast(color),
          overdue:
            remainingTasks[i].dueDate
            && new Date(remainingTasks[i].dueDate).getTime() < nowTimestamp,
          sortDateTimestamp: remainingTasks[i].completeDate
            ? new Date(remainingTasks[i].completeDate + 86400000).getTime() // we want complete events to sort at bottom of lists (adding 24 hours)
            : new Date(remainingTasks[i].startDate).getTime(),
          billablePrice: getConfiguredValue(remainingTasks[i].eventData, billablePriceFieldName)?.value,
          horseNote: getConfiguredValue(remainingTasks[i].eventData, horseNoteFieldName)?.value,
          customStatus: statuses.find(
            (s) => s.id === remainingTasks[i].currentEventStatus.status.id
              && s.id !== barnMetadata.statusStartId
              && s.id !== barnMetadata.statusPendingId
              && s.id !== barnMetadata.statusEndId,
          ),
        });
      }
    }
  }
  return overview;
};
